module.exports = {"priceNote":"*A service fee will be added to this transaction.","getDirections":"Get directions","showMore":"Show more","showLess":"Show less","presentedBy":"Presented by"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/Event/EventDetails/locales/en.json
// module id = 977
// module chunks = 0